import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'trade-discount',
    templateUrl: './trade-discount.component.html',
    styleUrls: ['./trade-discount.component.scss'],
    standalone: false
})
export class TradeDiscountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
